import { Permission, Role } from 'appwrite';
import { appwriteConfig } from '../../config/environment';
import { tablesDB } from '../../services/appwrite/client';

export type Gender = 'woman' | 'man' | 'nonBinary' | 'anotherIdentity' | 'preferNotToSay';
export type Disability =
  | 'none'
  | 'blindness'
  | 'lowVision'
  | 'hearing'
  | 'physical'
  | 'cognitive'
  | 'neurodivergent'
  | 'speech'
  | 'another'
  | 'preferNotToSay';

export interface RegistrationInput {
  firstName: string;
  lastName: string;
  preferredName: string;
  birthDate: Date;
  countryCode: string;
  timezone: string;
  gender: Gender;
  disabilities: Disability[];
  accessibilityNotes: string;
}

/**
 * Crea la fila de perfil de la propia cuenta.
 *
 * A diferencia del resto de la aplicación, esto **no** pasa por
 * `management-command`: la fila la crea el cliente directamente, con
 * permisos explícitos por fila (`rowId` es el propio `userId`, y solo esa
 * cuenta puede leerla, actualizarla o borrarla) — mismo camino que ya usa
 * `session-gateway.ts` para leerla. Evita depender de una acción de backend
 * que hoy no existe para esto.
 */
export async function createOwnProfile(userId: string, input: RegistrationInput): Promise<void> {
  await tablesDB.createRow({
    databaseId: appwriteConfig.databaseId,
    tableId: appwriteConfig.profilesTableId,
    rowId: userId,
    data: {
      firstName: input.firstName,
      lastName: input.lastName,
      preferredName: input.preferredName,
      birthDay: input.birthDate.getDate(),
      birthMonth: input.birthDate.getMonth() + 1,
      birthYear: input.birthDate.getFullYear(),
      countryCode: input.countryCode,
      timezone: input.timezone,
      gender: input.gender,
      disabilities: input.disabilities,
      accessibilityNotes: input.accessibilityNotes || null,
    },
    permissions: [
      Permission.read(Role.user(userId)),
      Permission.update(Role.user(userId)),
      Permission.delete(Role.user(userId)),
    ],
  });
}
